import { FC } from "react";
import {
  ALERT_BODY_ROW_START_CLASS_MAP,
  ALERT_DEFAULTS,
  TAlertBodyProps,
} from "./Alert.config";
import { cn } from "@/ui/lib";
import { getAlertCopyColumnClass } from "./Alert.utils";
import { TextBody } from "../../typography/TextBody";

export const AlertBody: FC<TAlertBodyProps> = ({ children, asset, orientation = ALERT_DEFAULTS.orientation }) => (
  <div
    data-component="AlertBody"
    className={cn(
      getAlertCopyColumnClass(asset),
      ALERT_BODY_ROW_START_CLASS_MAP[orientation],
      "text-foreground-muted-strong",
    )}
  >
    <TextBody
      tag="p"
      size={2}
      isResponsive={false}
      className="mb-0"
    >
      { children }
    </TextBody>
  </div>
);
